import { render, staticRenderFns } from "./ParticipantsDrawer.vue?vue&type=template&id=2f153572"
import script from "./ParticipantsDrawer.vue?vue&type=script&lang=js"
export * from "./ParticipantsDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports